import React, { FC, HTMLProps, useEffect, useMemo, useState } from "react";
import cn from "classnames";
import stl from "./index.module.scss";
import { nanoid } from "nanoid";
import { isPresent } from "../../utils";

interface Props extends Omit<HTMLProps<HTMLDivElement>, "value" | "onChange"> {
  inputProps?: HTMLProps<HTMLInputElement>;
  labelProps?: HTMLProps<HTMLLabelElement>;
  value?: boolean;
  onChange?: (value: boolean) => void;
}
const Checkbox: FC<Props> = ({
  inputProps,
  labelProps,
  children,
  value,
  onChange,
  ...props
}) => {
  const [localValue, setLocalValue] = useState<boolean>(false);

  const displayValue = isPresent(value) ? value : localValue;

  useEffect(() => {
    if (isPresent(value)) setLocalValue(value);
  }, [value]);

  const onChanges = (v: boolean) => {
    onChange?.(v);
    setLocalValue(v);
  };

  const id = useMemo<string>(() => {
    return inputProps?.id ?? nanoid();
  }, [inputProps?.id]);

  return (
    <div
      {...props}
      className={cn(props.className, stl.block, {
        [stl.checked]: displayValue,
      })}
    >
      <label
        {...labelProps}
        tabIndex={0}
        htmlFor={id}
        className={cn(labelProps?.className, stl.label)}
        onKeyDown={({ key }) => {
          if (key === "Enter" || key === " ") {
            onChanges(!displayValue);
          }
        }}
      >
        <input
          id={id}
          type="checkbox"
          onChange={({ target: { checked } }) => {
            onChanges(checked);
          }}
          checked={displayValue}
        />
      </label>
      {children}
    </div>
  );
};

export default Checkbox;
